import React, {useState, useEffect} from "react";
import {  Typography, CardActionArea, CardContent, Card, CardMedia, Box } from "@mui/material";
import { Link } from 'react-router-dom';
import { db } from "../../../firebase/firebaseConfig";
import { format, fromUnixTime } from 'date-fns';
import {es} from 'date-fns/locale';
import { collection, onSnapshot } from 'firebase/firestore';

const CardImplementacion = () => {
    const [implementaciones, setImplementacion] = useState([]);

    //formato de fecha
    const formatearFecha = (fecha) => {
        if (!fecha) {
        return ''; // Manejar caso de fecha inválida
        }
        return format(fromUnixTime(fecha), "dd 'de' MMMM", {locale: es});
    }

    const truncateText = (text, maxLength = 50) => {
        return text > maxLength ? text.slice(0, maxLength) + '...' : text;
    }

    useEffect(() => {
        onSnapshot(collection(db, 'implementacioncalocho'),
            (snapshot) => {
                const arregloImplementaciones = snapshot.docs.map((docImplementacion) => {
                    return {...docImplementacion.data(), id: docImplementacion.id};
                })
    
                setImplementacion(arregloImplementaciones);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);  


    return(
        <Box sx={{ width: '100%', }}>  
            {implementaciones.map((implementacion) => (
            <CardActionArea  sx={{marginBottom: '20px' }} key={implementacion.id} >
                <Link to={implementacion.urlarticulo} style={{ textDecoration: 'none' }}>
                
                    <Card sx={{
                        mb: 1,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexDirection: {
                            xs: 'column', // Cambia a columnas en dispositivos móviles
                            sm: 'row', 
                        }
                    }}>
                        <CardContent sx={{
                            display: "flex", 
                            justifyContent: 'center' ,
                            flexDirection: 'column',
                            width: '76%',
                        }}>
                            <Typography variant="h4" 
                                sx={{
                                    marginBottom: { xs: 1, sm: 2 },
                                    fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.8rem' }, 
                                    textAlign: 'center'
                                }}
                            >
                                {implementacion.titulo}
                            </Typography>
                            <Typography variant="h5" color="text.secondary" 
                                sx={{ 
                                    marginBottom: { xs: 1, sm: 2 },
                                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                                    textAlign: 'center'
                                }}
                            >
                                {implementacion.empresa}
                            </Typography>
                            <Typography variant="subtitle1" color="text.secondary" 
                                sx={{ 
                                    marginBottom: { xs: 1, sm: 2 },
                                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                                    textAlign: 'center'
                                }}
                            >
                                {formatearFecha(implementacion.fecha)}
                            </Typography>
                            <Typography variant="subtitle1" color="text.secondary" 
                                sx={{ 
                                    marginBottom: { xs: 1, sm: 2 },
                                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                                    textAlign: 'center'
                                }}
                            >
                                <span>{truncateText(implementacion.descripcion)}</span>
                            </Typography>
                            <Typography variant="subtitle1" color="#5d0303" 
                                sx={{ 
                                    marginBottom: { xs: 1, sm: 2 },
                                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                                    textAlign: 'center'
                                }}
                            >
                                {implementacion.urlarticulo}
                            </Typography>
                        </CardContent>
                        <CardMedia
                            component="img"
                            sx={{ width: { xs: 'none', sm: '35%'}, height: { xs: 'none', sm: '35%'}, display: { xs: 'flex', sm: 'flex' }, borderRadius: '1%', }}
                            image={implementacion.imagen}
                            alt={implementacion.titulo}
                        />
                    </Card>
                </Link>
            </CardActionArea>
            ))}
        </Box>
    );
}

export default CardImplementacion;